// extracted by mini-css-extract-plugin
export default {"dimmed":"Loading_dimmed__zYg9F"};